import gql from 'graphql-tag';
import ContentFields from '../fragments/content';

export default gql`
  query searchCategoryContent(
    $keywords: String!
    $limit: Int
  ) {
    searchCategoryContent(
      keywords: $keywords
      limit: $limit
    ) {
      ...ContentFields
    }
  }
  ${ContentFields}
`;
